console.log('Loading configuration from environment:', process.env);

// Runtime environment of the application
//
// Possible values are 'production', 'staging', and 'develop'
export const DS_ENV = process.env.REACT_APP_DS_ENV;

// Indicates whether the application has been built for embedding within
// an iframe on a specific host.
export const EMBED = process.env.REACT_APP_EMBED || process.env.STORYBOOK_EMBED;
